<ng-container *ngIf="control && control.invalid && (control.dirty || control.touched)">
  <small *ngIf="control.errors?.['required']" class="p-error">Este campo é obrigatório.</small>
  <small *ngIf="control.errors?.['email']" class="p-error">E-mail inválido.</small>
  <small *ngIf="control.errors?.['minlength']" class="p-error">
    Mínimo de {{ control.errors?.['minlength']?.requiredLength }} caracteres.
  </small>
  <small *ngIf="control.errors?.['maxlength']" class="p-error">
    Máximo de {{ control.errors?.['maxlength']?.requiredLength }} caracteres.
  </small>
  <small *ngIf="control.errors?.['pattern']" class="p-error">Formato inválido.</small>
</ng-container>